var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EqsSkeleton',_vm._b({staticClass:"global-text-editor",attrs:{"type":"article"}},'EqsSkeleton',{ loading: _vm.loading },false),[_c('div',{staticClass:"ProseMirror",domProps:{"innerHTML":_vm._s(_vm.getSanitizedHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }